import { AddComponent } from './pages/add/add.component';
import { SharedModule } from './../../../../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PreOwnedSuppliesRoutingModule } from './pre-owned-supplies-routing.module';
import { ListingComponent } from './pages/listing/listing.component';
import { DeleteMultipleComponent } from './components/delete-multiple/delete-multiple.component';
import { DeleteComponent } from './components/delete/delete.component';
import { ViewComponent } from './pages/view/view.component';
import { NgxMatColorPickerModule } from '@angular-material-components/color-picker';
import { CKEditorModule } from 'ckeditor4-angular';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { UploadModule } from 'src/app/shared/modules/upload/upload.module';
import { BidsListingComponent } from './pages/bids-listing/bids-listing.component';
import { SubCategoryPipe } from './filters/sub-category.pipe';
import { CategoryPipe } from './filters/category.pipe';
import { BrandPipe } from './filters/brand.pipe';
import { SendForApprovalComponent } from './components/send-for-approval/send-for-approval.component';
import { ViewReasonComponent } from './components/view-reason/view-reason.component';
import { RejectComponent } from './components/reject/reject.component';
import { ApproveComponent } from './components/approve/approve.component';
import { ActiveComponent } from './components/active/active.component';
import { InactiveComponent } from './components/inactive/inactive.component';
import { SendForApprovalMultipleComponent } from './components/send-for-approval-multiple/send-for-approval-multiple.component';
import { ApproveMultipleComponent } from './components/approve-multiple/approve-multiple.component';
import { AddSupplyCategoryComponent } from './components/add-supply-category/add-supply-category.component';
import { AddSupplySubCategoryComponent } from './components/add-supply-sub-category/add-supply-sub-category.component';
import { AddSupplyBrandComponent } from './components/add-supply-brand/add-supply-brand.component';
import { AddPriceUnitComponent } from './components/add-price-unit/add-price-unit.component';
import { StopBidComponent } from './components/stop-bid/stop-bid.component';
import { CloseBidComponent } from './components/close-bid/close-bid.component';
import { MetroRegionPipe } from './pipes/metro-region.pipe';
import { SuburbanPipe } from './pipes/suburban.pipe';
import { AngularEditorModule } from '@kolkov/angular-editor';

@NgModule({
  declarations: [
    ListingComponent,
    DeleteMultipleComponent,
    DeleteComponent,
    DeleteMultipleComponent,
    ViewComponent,
    AddComponent,
    BidsListingComponent,
    SubCategoryPipe,
    CategoryPipe,
    BrandPipe,
    SendForApprovalComponent,
    ViewReasonComponent,
    RejectComponent,
    ApproveComponent,
    ActiveComponent,
    InactiveComponent,
    SendForApprovalMultipleComponent,
    ApproveMultipleComponent,
    AddSupplyCategoryComponent,
    AddSupplySubCategoryComponent,
    AddSupplyBrandComponent,
    AddPriceUnitComponent,
    StopBidComponent,
    CloseBidComponent,
    MetroRegionPipe,
    SuburbanPipe
  ],
  imports: [
    CommonModule,
    PreOwnedSuppliesRoutingModule,
    SharedModule,
    CKEditorModule,
    NgxMatColorPickerModule,
    UploadModule,
    SwiperModule,
    NgxMatSelectSearchModule,
    AngularEditorModule
  ]
})
export class PreOwnedSuppliesModule { }
